import React from "react";
import { Image } from "antd";
import errore from "../../styles/images/errorPage.png";

export const ErrorPage = ({ errorMessage }) => (
  <div className="errorPage">
    <Image id="regione" width={400} src={errore} preview={false} />
    <div id="message">
      <span>{errorMessage && errorMessage !== undefined ? errorMessage : "Ops! Qualcosa è andato storto"}</span>
    </div>
  </div>
);
